module.exports = __webpack_public_path__ + "static/banner-image-a01320ffb78e68dd829adf6257a9454a.png";